import { Controller } from 'stimulus'
import { format } from 'date-fns'

export default class extends Controller {
  static targets = ['time', 'year', 'yearJa', 'month', 'date', 'day']

  connect() {
    const now = new Date()
    const today = {
      year: now.getFullYear(),
      month: now.getMonth(),
      date: now.getDate(),
      day: now.getDay(),
    }
    const day = ['日', '月', '火', '水', '木', '金', '土']

    this.timeTarget.setAttribute('datetime', format(new Date(today.year, today.month, today.date), 'yyyy-MM-dd'))
    this.yearTarget.innerHTML = today.year
    this.yearJaTarget.innerHTML = today.year - 2018
    this.monthTarget.innerHTML = today.month + 1
    this.dateTarget.innerHTML = today.date
    this.dayTarget.innerHTML = day[today.day]

    this.element.removeAttribute('hidden')
  }
}